import { getPricingOfAccountRCSCampaign } from "../types/account_campaign_pricing_rcs_types";


const initState = {
  data: [],
  loading: false,
  error: null,
  cellLoading: null,
};

export default function accountCampaignPricingRCSReducer(state = initState, action = {}) {
  switch (action.type) {
    case getPricingOfAccountRCSCampaign.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getPricingOfAccountRCSCampaign.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getPricingOfAccountRCSCampaign.ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
